import { render } from "./SellerToProduct.vue?vue&type=template&id=5c830a3e&scoped=true"
import script from "./SellerToProduct.vue?vue&type=script&lang=js"
export * from "./SellerToProduct.vue?vue&type=script&lang=js"

import "@/assets/css/components/commonPopup.css?vue&type=style&index=0&id=5c830a3e&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c830a3e"]])

export default __exports__